import React from "react";
import './Header.css';

function Header({ onPageChange }) {
  return (
    <nav className="Header">
      <ul>
        <li><button onClick={() => onPageChange("início")}>INÍCIO</button></li>
        <li><button onClick={() => onPageChange("posição-do-analista")}>POSIÇÃO DO ANALISTA</button></li>
        <li><button onClick={() => onPageChange("jacques-lacan")}>JACQUES LACAN</button></li>
        {/* <Dropdown title="ASSUNTOS EM PSICANÁLISE" onPageChange={onPageChange}>
          <ul className="submenu">
            <li><button onClick={() => onPageChange("toxicomanias")}>Adicções: toxicomanias contemporâneas</button></li>
            <li><button onClick={() => onPageChange("estruturas")}>Estruturas clínicas</button></li>
          </ul>
        </Dropdown> */}
      </ul>
    </nav>
  );
}

// const Dropdown = ({ title, children, onPageChange }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   function toggleOpen() {
//     setIsOpen(!isOpen)
//   }

//   return (
//     <li
//       className="dropdown"
//       onMouseEnter={() => setIsOpen(true)}
//       onMouseLeave={() => setIsOpen(false)}
//       onClick={toggleOpen}
//     >
//       <button>{title}</button>
//       {/* Exibe o submenu apenas quando isOpen for verdadeiro */}
//       {isOpen && (
//         <div className="submenu-container">
//           {children}
//         </div>
//       )}
//     </li>
//   );
// };

export default Header;
